import { Component, OnInit, Input } from '@angular/core';
import { ValidatorMessageModel } from '../../form/form-helpers/validation/validator-message.model';
import { SelectedItem } from './models/selected-item.model';
import { ToastService } from '../../../shared/foundation/toast/toast.service';
import { TranslationMessagesPipe } from '../../../shared/pipes/translation-msg.pipe';

@Component({
  selector: 'app-selected-items',
  templateUrl: './selected-items.component.html',
  styleUrls: ['./selected-items.component.scss'],
})
export class SelectedItemsComponent implements OnInit {
  @Input() validatorMessage?: string;
  @Input() itemAlreadyAddedMessage?: string;
  @Input() invalidSelectionMessage?: string;

  items?: SelectedItem[];

  wasValidated = false;

  constructor(
    private toastService: ToastService,
    private msgPipe: TranslationMessagesPipe
  ) {}

  ngOnInit(): void {
    this.resetItems();
  }

  addItem(item: SelectedItem): void {
    const found = this.items?.find((e) => item.identifier === e.identifier);
    if (!this.items?.every((building) => building.key === item.key)) {
      this.toastService.showWarningToast(
        this.msgPipe.transformInstant(
          this.invalidSelectionMessage
            ? this.invalidSelectionMessage
            : 'toasts.differentParcelNumber'
        ),
        1000
      );
    }
    if (!found) {
      this.items?.push(item);
    } else {
      this.toastService.showWarningToast(
        this.msgPipe.transformInstant(
          this.itemAlreadyAddedMessage
            ? this.itemAlreadyAddedMessage
            : 'toasts.itemAlreadyAdded'
        ),
        1000
      );
    }
  }

  removeItem(index: number): void {
    this.items?.splice(index, 1);
  }

  resetItems(): void {
    this.items = [];
  }

  getSelectedItems(): SelectedItem[] {
    return this.items!;
  }

  getSelectedIdentifiers(): string[] {
    return this.items?.map(function (item) {
      return item['identifier'];
    })!;
  }

  trigger(): void {
    this.wasValidated = true;
  }

  checkIfValid(): boolean {
    return this.items?.length != 0;
  }

  getValidationMessages(): ValidatorMessageModel[] | null {
    const errorsMessages: ValidatorMessageModel[] = [];
    if (!this.items || this.items.length == 0) {
      errorsMessages.push(
        new ValidatorMessageModel(
          this.validatorMessage
            ? this.validatorMessage
            : 'validators.selectItem'
        )
      );

      return errorsMessages;
    }
    return null;
  }
}
